module.exports = __webpack_public_path__ + "static/media/CA1B0C38-1ADD-416B-9899-092900F4AA3E 7.1b601fc8.JPG";